export const USER_JOURNEY_NAMES = {
  LOGIN: 'login',
  TAXES_UPGRADE: 'taxes-upgrade',
} as const

export type UserJourneyName = (typeof USER_JOURNEY_NAMES)[keyof typeof USER_JOURNEY_NAMES]
